import { Text, View, StyleSheet, TouchableOpacity } from 'react-native';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Button, ButtonTypes } from '../components';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { Icon } from '../components';
import { NavigatorService } from '../utils/NavigatorService';
import { UserDataConsumer } from '../utils';

class EliteEndSessionConfirmComponent extends Component {
  public render() {
    const { t, navigation, user } = this.props;
    return (
      <View style={styles.container}>
        <View style={styles.closeIconContainer}>
          <TouchableOpacity
            hitSlop={{
              bottom: defaultScale(20),
              top: defaultScale(20),
              left: defaultScale(20),
              right: defaultScale(20),
            }}
            disabled={false}
            onPress={() => navigation.goBack()}
          >
            <Icon name='md-close' color={Theme.GREY} size={defaultScale(30)} />
          </TouchableOpacity>
        </View>
        <View style={styles.headingsContainer}>
          <Text style={styles.endSessionWithName}>
            {t('wantToEndYourSession', { name: user.userProfile.firstname })}
          </Text>
          <Text style={styles.canStartNewSessionText}>
            {t('canQuicklyStartANewSession')}
          </Text>
        </View>
        <View style={styles.buttonsContainer}>
          <Button
            title={t('YesEndSession')}
            containerStyle={styles.buttonStyle}
            onPress={() => NavigatorService.navigateContainerOne('Loading')}
            buttonType={ButtonTypes.NORMAL}
            overrideFontStyles={styles.endSessionButtonTextStyle}
          />
          <Button
            title={t('cancel')}
            containerStyle={styles.buttonStyle}
            onPress={() => navigation.goBack()}
            buttonType={ButtonTypes.OUTLINE}
            overrideFontStyles={styles.cancelButtonTextStyle}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  closeIconContainer: {
    padding: defaultScale(15),
    alignSelf: 'flex-end',
  },
  headingsContainer: {
    alignSelf: 'center',
    paddingHorizontal: defaultScale(20),
  },
  buttonsContainer: {
    padding: defaultScale(20),
  },
  endSessionWithName: {
    ...Theme.textStyle.bodyCopyBold,
    fontSize: defaultScale(21),
    color: Theme.DARK_CHARCOAL,
    paddingVertical: defaultScale(10),
  },
  canStartNewSessionText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM,
  },
  buttonStyle: {
    marginVertical: defaultScale(10),
  },
  endSessionButtonTextStyle: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.WHITE,
  },
  cancelButtonTextStyle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
  },
});

const EliteEndSessionConfirm = UserDataConsumer(EliteEndSessionConfirmComponent);
export default translate(['elite'], { wait: true })(
  EliteEndSessionConfirm,
);
